import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const serviceLocaleModule: LocaleModule = {
  name: "service",
  messages: { en: en, it: it },
};
